import i18n from './../../../shared/i18n';
import BaseModel from "./../../components/input-widget/BaseModel";

export default class Increment extends BaseModel {
  max = null;
  increment = null;

  rules = {
    max: 'required',
    increment: 'required',
  };

  attributeLabels = {
    max: i18n.t('Max'),
    increment: i18n.t('Increment'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
